import type { Sport } from '@pacevault/engine/types.ts';
import type { TrackIntensity } from '@/store/mapPreferences.ts';

export const ADDITIVE_BLEND = {
  blendColorSrcFactor: 'src-alpha',
  blendColorDstFactor: 'one',
  blendColorOperation: 'add',
  blendAlphaSrcFactor: 'one',
  blendAlphaDstFactor: 'one',
  blendAlphaOperation: 'add',
} as const;

export const trackModifiers = {
  width: { default: 8, highlighted: 12 },
  alpha: { default: 80, highlighted: 255 },
};

export const LAP_DIMMED_BRIGHTNESS = 0.8;
export const LAP_CASING_SCALE = 1.6;

export const ALPHA_BY_TRACK_INTENSITY: Record<TrackIntensity, number> = {
  faint: trackModifiers.alpha.default,
  warm: 160,
  hot: 255,
};

export const studioRouteModifiers = {
  width: { default: 8, highlighted: 12 },
  alpha: { default: 255, hidden: 0 },
};

export const TRACK_COLOR_BY_SPORT: Record<Sport, [number, number, number]> = {
  running: [74, 222, 128],
  cycling: [249, 115, 22],
};

// Live "you are here" position. The accuracy disc mirrors the glass surface
// (translucent white fill + faint white border); the dot is a solid locator
// with a white ring, à la Google/Apple Maps.
export const geoAccuracyFill: [number, number, number, number] = [255, 255, 255, 18];
export const geoAccuracyLine: [number, number, number, number] = [255, 255, 255, 38];
export const geoDotFill: [number, number, number, number] = [80, 140, 255, 255];
export const geoDotLine: [number, number, number, number] = [255, 255, 255, 255];

export const HIGHLIGHT_TRANSITIONS = { getWidth: 300, getColor: 300 };
